import * as React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { CustomBreadcrumbs } from "./styles";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import Approve from "../subSellerButtons/approve";
import Reject from "../subSellerButtons/reject";
import { useNavigate, useParams } from "react-router-dom";
import {
  approveSubseller,
  getAllProfileStatuses,
  getAllRejectedReason,
  getProfileDetail,
} from "../../redux/slices/subSellerSlice";
import { useDispatch, useSelector } from "react-redux";
import { backToSubseller } from "../../redux/slices/subSellerSlice";
import { ROLES } from "../../utils/constants";

const SubSellerProfile = ({ navigateHome }) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const navigate = useNavigate();
  const params = useParams();

  const state = useSelector(
    ({
      subSeller: { profileStatuses, profileDetail, rejectReason },
      seller: { msal },
    }) => ({
      profileStatuses,
      profileDetail,
      rejectReason,
      msal,
    })
  );

  const isMobile = useMediaQuery((theme) =>
    theme.breakpoints.between("sm", "md")
  );
  // const isTablet = useMediaQuery((theme) =>
  //   theme.breakpoints.between("md", "lg")
  // );
  console.log(state.msal.roles);
  const [formEdit, setFormEdit] = React.useState(false);
  const [showProfile, setShowProfile] = React.useState(false);

  const [status, setStatus] = React.useState("");
  const [reason, setReason] = React.useState("");
  const [reasonId, setReasonId] = React.useState("");
  const [comment, setComment] = React.useState("");

  React.useEffect(() => {
    dispatch(getProfileDetail({ sellerId: params.id }));
    dispatch(getAllProfileStatuses());
    dispatch(getAllRejectedReason());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (state?.profileDetail?.data?.[0]?.status_en === "Pending") {
      setStatus("");
    }
    if (state?.profileDetail?.data?.[0]?.status_en !== "Pending") {
      setStatus(state?.profileDetail?.data?.[0]?.status_en);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.profileDetail?.data?.[0]?.status_en]);

  const handleBack = () => {
    dispatch(backToSubseller(true));
    navigate("/");
    navigateHome(1, 1);
  };
  const toggleProfile = () => setShowProfile(!showProfile);

  const handleStatusChange = (e) => {
    setStatus(e.target.value);
    setReason("");
    setReasonId("");
    setComment("");
  };

  const handleProfileEdit = () => {
    setFormEdit(!formEdit);
  };

  const handleApproveSubseller = () => {
    dispatch(
      approveSubseller({
        sellerId: params.id,
        data: { sub_seller_status_id: "SSS002" },
      })
    );
  };

  const handleRejectSubseller = () => {
    dispatch(
      approveSubseller({
        sellerId: params.id,
        data: {
          sub_seller_status_id: "SSS003",
          sub_seller_rejection_reason_id: reasonId,
          rejection_reason_comments: comment,
        },
      })
    );
  };

  const handleChange = (e, type) => {
    if (type === "comment") {
      setComment(e.target.value);
    }
    if (type === "reason") {
      const key = state?.rejectReason?.data?.find(
        (v) => v.rejection_reason_en === e.target.value
      );
      setReasonId(key?.sub_seller_rejection_reason_id);
      setReason(e.target.value);
    }
  };

  const displayColor = (st) => {
    if (st === "Pending") return "#0074AD";
    if (st === "Approved") return "#20842F";
  };

  return (
    <Box
      sx={{
        top: "4.5rem",
        position: "relative",
        px: isMobile ? "1rem" : "3rem",
        my: 3,
      }}
    >
      <Box
        sx={{
          display: "inline-flex",
          position: "relative",
          alignItems: "center",
          my: 1,
        }}
      >
        {isMobile ? (
          <>
            {formEdit ? (
              <Box
                sx={{
                  display: "inline-flex",
                  position: "relative",
                  alignItems: "center",
                }}
                tabIndex={0}
                onClick={() => {
                  handleProfileEdit();
                  toggleProfile();
                }}
                onKeyUp={(e) => {
                  !e.shiftKey &&
                    (e.key === "Enter" || e.key === " ") &&
                    handleProfileEdit(e);
                  toggleProfile();
                }}
              >
                <ArrowBackIosNewIcon sx={{ fontSize: ".65rem" }} />{" "}
                <Typography
                  sx={{
                    fontSize: ".75rem",
                    pl: ".4rem",
                    fontWeight: 600,
                    lineHeight: "1.125rem",
                  }}
                  component="div"
                >
                  Back to Sabre List
                </Typography>
              </Box>
            ) : (
              <Box
                sx={{
                  display: "inline-flex",
                  position: "relative",
                  alignItems: "center",
                }}
                tabIndex={0}
                onClick={handleBack}
                onKeyUp={(e) =>
                  !e.shiftKey &&
                  (e.key === "Enter" || e.key === " ") &&
                  handleBack(e)
                }
              >
                <ArrowBackIosNewIcon sx={{ fontSize: ".65rem" }} />{" "}
                <Typography
                  sx={{
                    fontSize: ".75rem",
                    pl: ".4rem",
                    fontWeight: 600,
                    lineHeight: "1.125rem",
                    color: "#000000",
                  }}
                  component="div"
                >
                  Back to Sub-Seller List
                </Typography>
              </Box>
            )}
          </>
        ) : (
          <CustomBreadcrumbs separator={<NavigateNextIcon fontSize="small" />}>
            <Typography
              sx={{
                fontSize: ".75rem",
                fontWeight: 600,
                lineHeight: "1.125rem",
                cursor: "pointer",
                color: "#000000",
              }}
              component="div"
              onClick={handleBack}
            >
              Sub-Seller List
            </Typography>
            <Typography
              sx={{
                fontSize: ".75rem",
                cursor: "pointer",
                fontWeight: 400,
                lineHeight: "1.125rem",
                color: "#000000",
              }}
              component="div"
              onClick={() => {
                setFormEdit(false);
              }}
            >
              {state?.profileDetail?.data?.[0]?.travel_agency_name}
            </Typography>
          </CustomBreadcrumbs>
        )}
      </Box>

      <Grid container spacing={6} sx={{ mb: 2, pt: 1 }}>
        <Grid item xs={12} md={12} lg={12}>
          <Box
            sx={{
              bgcolor: "white",
              mb: 2,
              pb: ".8rem",
              borderRadius: 3,
            }}
          >
            <Box
              sx={{
                p: "1.5rem",
              }}
            >
              <Typography
                sx={{
                  fontSize: "2.25rem",
                  fontWeight: 600,
                  mb: "2rem",
                  lineHeight: "2.625rem",
                }}
              >
                {state?.profileDetail?.data?.[0]?.travel_agency_name}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                  columnGap: 4,
                  flexDirection: isMobile ? "column" : "row",
                  rowGap: 4,
                }}
              >
                <Box
                  sx={{
                    bgcolor: "#f5f5f5",
                    display: "flex",
                    flex: 1,
                    flexDirection: "column",
                    borderRadius: 4,
                    p: 2,
                  }}
                >
                  <Typography
                    sx={{
                      color: `${displayColor(
                        state?.profileDetail?.data?.[0]?.status_en
                      )}`,
                      fontSize: "1.25rem",
                      fontFamily: "Open Sans",
                      fontWeight: 600,
                      lineHeight: "1.375rem",
                      pb: "1.5rem",
                    }}
                  >
                    {`${
                      state?.profileDetail?.data?.[0]?.status_en === "Pending"
                        ? "Pending Approval"
                        : state?.profileDetail?.data?.[0]?.status_en || ""
                    }`}
                  </Typography>

                  {state?.profileDetail?.data?.[0]?.rejection_reason_en &&
                    state?.profileDetail?.data?.[0]
                      ?.rejection_reason_comments && (
                      <>
                        <Typography
                          gutterBottom
                          sx={{
                            fontSize: ".8rem",
                            fontWeight: 400,
                            lineHeight: "1.25rem",
                            color: theme.palette.doveGray,
                          }}
                        >
                          Reason:{" "}
                          {state?.profileDetail?.data?.[0]?.rejection_reason_en}
                        </Typography>
                        <Typography
                          gutterBottom
                          sx={{
                            fontSize: ".8rem",
                            fontWeight: 400,
                            lineHeight: "1.25rem",
                            color: theme.palette.doveGray,
                            mb: 3,
                          }}
                        >
                          Comment:{" "}
                          {state?.profileDetail?.data?.[0]
                            ?.rejection_reason_comments || "None"}
                        </Typography>
                      </>
                    )}
                  {state.msal.roles.some(
                    (role) =>
                      role === ROLES.SUPER_ADMIN ||
                      role === ROLES.BUSINESS_ADMIN
                  ) ? (
                    <FormControl variant="standard" sx={{ mb: 1 }}>
                      <InputLabel
                        id="selectedStatus"
                        sx={{
                          fontSize: "1rem",
                          fontWeight: 400,
                          lineHeight: "1.25rem",
                          color: "#000000",
                        }}
                      >
                        Set status
                      </InputLabel>
                      <Select
                        labelId="selectedStatus"
                        size="small"
                        value={status}
                        onChange={handleStatusChange}
                        sx={{
                          bgcolor: "inherit",
                          fontWeight: 600,
                          mr: isMobile ? 0 : "5rem",
                          py: ".4rem",
                        }}
                      >
                        {state?.profileStatuses?.status?.map((v) => {
                          return (
                            <MenuItem value={v.status_en}>
                              {v.status_en}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  ) : null}

                  <Box
                    sx={{
                      mr: isMobile ? 0 : "5rem",
                      display: "flex",

                      flexDirection: "column",
                    }}
                  >
                    {status === "Approved" &&
                      state?.profileDetail?.data?.[0]?.status_en !==
                        "Approved" && (
                        <Approve
                          handleApproveSubseller={handleApproveSubseller}
                        />
                      )}
                    {status === "Rejected" &&
                      state?.profileDetail?.data?.[0]?.status_en !==
                        "Rejected" && (
                        <Reject
                          reason={reason}
                          comment={comment}
                          handleChange={handleChange}
                          handleRejectSubseller={handleRejectSubseller}
                          subSellerRejectReasonData={state?.rejectReason}
                        />
                      )}
                  </Box>
                </Box>
                <Box sx={{ display: "flex", flex: 1 }}>Timeline</Box>
              </Box>
            </Box>
            <Divider sx={{ borderColor: "#EFEFEF", mt: 2 }} />
            <Accordion
              disableGutters
              elevation={0}
              sx={{ "&:before": { height: 0 } }}
              expanded={showProfile}
              onChange={toggleProfile}
            >
              <AccordionSummary
                sx={{
                  "& .MuiAccordionSummary-content": {
                    flexGrow: 0,
                  },
                  justifyContent: "start",
                  color: theme.palette.darkBlue,
                  ml: 1.5,
                }}
                expandIcon={
                  <KeyboardArrowDownIcon
                    sx={{ color: `${theme.palette.darkBlue} !important` }}
                  />
                }
              >
                <Typography fontWeight={600}>Profile Details</Typography>
              </AccordionSummary>
              <AccordionDetails>
                {state?.profileDetail?.data?.map((v) => (
                  <Grid
                    container
                    flexDirection={"row"}
                    columnSpacing={4}
                    sx={{ pl: "1rem" }}
                  >
                    <Grid
                      item
                      container
                      xs={12}
                      md={8}
                      lg={8}
                      columnSpacing={3}
                      flexDirection={"column"}
                    >
                      <Grid item container rowSpacing={3} columnSpacing={3}>
                        <Grid
                          item
                          container
                          rowSpacing={3}
                          columnSpacing={3}
                          flexDirection={"column"}
                          xs={12}
                          md={5}
                          lg={5}
                        >
                          <Grid item>
                            <Typography
                              sx={{
                                color: "#4A4F55",
                                fontSize: "0.75rem",
                                fontWeight: 400,
                                lineHeight: "1.125rem",
                              }}
                              gutterBottom
                            >
                              Business Type
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: "1rem",
                                fontWeight: 600,
                                lineHeight: "1.375rem",
                                color: "#000000",
                              }}
                            >
                              {`${v.company_name} - ${v.business_type_en}`}
                            </Typography>
                          </Grid>
                        </Grid>
                        <Grid
                          item
                          container
                          rowSpacing={3}
                          flexDirection={"column"}
                          xs={12}
                          md={7}
                          lg={7}
                          columnSpacing={3}
                        >
                          <Grid item>
                            <Typography
                              sx={{
                                color: "#4A4F55",
                                fontSize: "0.75rem",
                                fontWeight: 400,
                                lineHeight: "1.125rem",
                              }}
                              gutterBottom
                            >
                              IATA Number
                            </Typography>
                            <Typography
                              sx={{
                                fontFamily: "Open Sans",
                                fontSize: "1rem",
                                fontWeight: 600,
                                lineHeight: "1.375rem",
                                color: "#000000",
                              }}
                            >
                              {v.iata_number}
                            </Typography>
                          </Grid>
                        </Grid>

                        <Grid
                          item
                          container
                          rowSpacing={3}
                          columnSpacing={3}
                          flexDirection={"column"}
                          xs={12}
                          md={5}
                          lg={5}
                        >
                          <Grid item>
                            <Typography
                              sx={{
                                color: "#4A4F55",
                                fontSize: "0.75rem",
                                fontWeight: 400,
                                lineHeight: "1.125rem",
                              }}
                              gutterBottom
                            >
                              Contact Name
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: "1rem",
                                fontWeight: 600,
                                lineHeight: "1.375rem",
                                color: "#000000",
                              }}
                            >
                              {`${v.contact_first_name} - ${v.contact_last_name}`}
                            </Typography>
                          </Grid>
                        </Grid>
                        <Grid
                          item
                          container
                          rowSpacing={3}
                          flexDirection={"column"}
                          xs={12}
                          md={7}
                          lg={7}
                          columnSpacing={3}
                        >
                          <Grid item>
                            <Typography
                              sx={{
                                color: "#4A4F55",
                                fontSize: "0.75rem",
                                fontWeight: 400,
                                lineHeight: "1.125rem",
                              }}
                              gutterBottom
                            >
                              Email Address
                            </Typography>
                            <Typography
                              sx={{
                                fontFamily: "Open Sans",
                                fontSize: "1rem",
                                fontWeight: 600,
                                lineHeight: "1.375rem",
                                color: "#000000",
                              }}
                            >
                              {v.agency_email}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                    {isMobile ? (
                      <Box marginBottom={1}>&nbsp;</Box>
                    ) : (
                      <Divider
                        orientation="vertical"
                        flexItem
                        sx={{ pl: "2rem" }}
                      />
                    )}
                    <Grid
                      item
                      container
                      columnSpacing={3}
                      xs={12}
                      md={3}
                      lg={3}
                    >
                      <Grid
                        item
                        container
                        flexDirection={"column"}
                        rowSpacing={3}
                      >
                        <Grid item>
                          <Typography
                            sx={{
                              color: "#4A4F55",
                              fontSize: "0.75rem",
                              fontFamily: "Open Sans",
                              fontWeight: 400,
                              lineHeight: "1.125rem",
                            }}
                            gutterBottom
                          >
                            Agency Phone Number
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "1rem",
                              fontFamily: "Open Sans",
                              width: "13.5625rem",
                              fontWeight: 600,
                              lineHeight: "1.375",
                              color: theme.palette.navbarBg,
                              display: "block",
                            }}
                            width={"6rem"}
                            variant="text"
                          >
                            {v.agency_phone_number}
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Typography
                            sx={{
                              color: "#4A4F55",
                              fontSize: "0.75rem",
                              fontFamily: "Open Sans",
                              fontWeight: 400,
                              lineHeight: "1.125rem",
                            }}
                            gutterBottom
                          >
                            Agency Website
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "1rem",
                              fontFamily: "Open Sans",
                              fontWeight: 600,
                              lineHeight: "1.375",
                              color: theme.palette.navbarBg,
                              display: "block",
                            }}
                            width={"6rem"}
                            variant="text"
                          >
                            {v.agency_website}
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Typography
                            sx={{
                              color: "#4A4F55",
                              fontSize: "0.75rem",
                              fontFamily: "Open Sans",
                              fontWeight: 400,
                              lineHeight: "1.125rem",
                            }}
                            gutterBottom
                          >
                            Agency Address
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "1rem",
                              fontWeight: 600,
                              fontFamily: "Open Sans",
                              lineHeight: "1.375",
                              color: theme.palette.navbarBg,
                              display: "block",
                            }}
                            width={"6rem"}
                            variant="text"
                          >
                            {v.agency_address}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                ))}
              </AccordionDetails>
            </Accordion>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SubSellerProfile;
